module.exports = __webpack_public_path__ + "img/item_4.4f29757e.png";